import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithHydra, exchangeCodeForToken } from '../hydraApiService';

const Callback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Completing login...');

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const login_challenge = params.get('login_challenge');
      const code = params.get('code');
      const error = params.get('error');

      // Handle error from Hydra
      if (error) {
        setStatus('Login failed: ' + params.get('error_description'));
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      // Step 2: Hydra redirected here with login_challenge
      if (login_challenge) {
        try {
          const email = localStorage.getItem('pending_email');       // ← CHANGED from sessionStorage
          const password = localStorage.getItem('pending_password'); // ← CHANGED from sessionStorage

          if (!email || !password) {
            setStatus('Session expired. Redirecting to login...');
            setTimeout(() => navigate('/login'), 2000);
            return;
          }

          localStorage.removeItem('pending_email');    // ← CHANGED from sessionStorage
          localStorage.removeItem('pending_password'); // ← CHANGED from sessionStorage

          setStatus('Verifying credentials...');
          const loginResponse = await loginWithHydra(email, password, login_challenge);
          console.log('Full redirect_to:', loginResponse.redirect_to);

          // Step 3: Follow Hydra's redirect_to (consent → code)
          window.location.href = loginResponse.redirect_to;

        } catch (err) {
          setStatus('Login failed: ' + err.message);
          setTimeout(() => navigate('/login'), 3000);
        }
        return;
      }

      // Step 4: Hydra redirected here with authorization code
      if (code) {
        try {
          setStatus('Fetching access token...');
          const tokenResponse = await exchangeCodeForToken(code);

          // Store Hydra tokens
          localStorage.setItem('access_token', tokenResponse.access_token);
          localStorage.setItem('id_token', tokenResponse.id_token);

          // Keep authToken pointing to id_token so existing code still works
          localStorage.setItem('authToken', tokenResponse.id_token);

          // Decode and store user info from id_token
          const payload = JSON.parse(atob(tokenResponse.id_token.split('.')[1]));
          localStorage.setItem('userEmail', payload.email || '');
          localStorage.setItem('userRole', payload.type || payload.role || ''); // ← CHANGED: check type first

          setStatus('Login successful! Redirecting...');
          setTimeout(() => navigate('/dashboard'), 500);

        } catch (err) {
          setStatus('Token exchange failed: ' + err.message);
          setTimeout(() => navigate('/login'), 3000);
        }
        return;
      }

      // Nothing in URL — shouldn't land here directly
      navigate('/login');
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '16px',
      fontFamily: 'sans-serif',
      color: '#444'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid #e2e8f0',
        borderTop: '3px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }}/>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <p style={{ margin: 0, fontSize: '14px' }}>{status}</p>
    </div>
  );
};

export default Callback;